/* istanbul ignore file */
import React from 'react';
import { useParams } from 'react-router-dom';
import SkillBasedQueueBreadcrumbs from 'domain/gpo/skillBasedQueue/shared/SkillBasedQueueBreadcrumbs';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useSkillBasedQueueUrl } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';

const SingleSkillBasedQueueBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getSingleEntityUrl } = useSkillBasedQueueUrl();
  const { id } = useParams<Dictionary<string>>();

  return (
    <SkillBasedQueueBreadcrumbs>
      <SingleBreadcrumbItem entity={id!} link={getSingleEntityUrl(id)} />
      {children}
    </SkillBasedQueueBreadcrumbs>
  );
};

export default SingleSkillBasedQueueBreadcrumbs;
